module.exports = __webpack_public_path__ + "static/ac-2-51ef2005db2a4c6621f21ae0caa20b68.jpg";